import { Box, Typography, Image, MediaBox } from "@jewlr/storybook/core"
import styled from "styled-components"

const ProtectionPlanBanner = styled(MediaBox).attrs((props) => ({
  bg: props.theme.extendWarranty.protectionPlanBanner.bg,
}))``

const ProtectionCoverage = () => {
  return (
    <>
      <ProtectionPlanBanner greaterThanOrEqual="tablet" mb={6}>
        <Box margin="auto" maxWidth="1024px">
          <Box alignItems="center" contain display="flex">
            <Box flex="1" px={3} textAlign="center">
              <Image
                alt="Protection Coverage"
                ratio="772 / 142"
                srcSet={`${require("images/checkout/extend/jewlr-extend.png")} 772w, ${require("images/checkout/extend/jewlr-extend-2x.png")} 1544w`}
                width="472"
              />
              <Typography fontSize="32px">Add Protection Coverage</Typography>
            </Box>
            <Box flex="1">
              <Image
                alt="Extend"
                ratio="1280 / 1167"
                src={`${sl.config.jewlr_asset_url}images/info/warranty/jewlr4-warranty-protection.png`}
                width="472"
              />
            </Box>
          </Box>
        </Box>
      </ProtectionPlanBanner>
      <ProtectionPlanBanner lessThan="tablet" py={5} textAlign="center">
        <Image
          alt="Protection Coverage"
          mb={2}
          ratio="356 / 246"
          srcSet={`${require("images/checkout/extend/m-jewlr-extend.png")} 356w, ${require("images/checkout/extend/m-jewlr-extend-2x.png")} 712w`}
          width="206"
        />
        <Typography fontSize="30px" px={6}>
          Add Protection Coverage
        </Typography>
      </ProtectionPlanBanner>
    </>
  )
}

export default ProtectionCoverage
